defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Card/CardFlowHeader',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/HelpButton'
  ],
  function (m, HelpButton) {
    // Context:
    var CardFlowHeader = function (args) {
      var title = args.title;
      var description = args.description;
      var goBack = args.goBack;
      var helpOverlay = args.helpOverlay;

      // Return:
      return m('.play-together-card-flow-header', [
        goBack || helpOverlay ? m('.play-together-card-flow-header__top', [
          m('.card-flow-header__left-wrapper', goBack ? m('.back-button', {
            onclick: goBack
          }, m('svg', { class: 'icon' }, [
            m('use', { href: '/Components/DanskeSpil/Domain/NumberGames/Graphics/SpriteSheets/MultiClientCommonIcons.svg#back-icon' })
          ])) : null),
          m('.card-flow-header__center-wrapper'),
          m('.card-flow-header__right-wrapper', helpOverlay ? HelpButton(helpOverlay) : null)
        ]) : null,
        title ? m('.play-together-card-flow-header__title', title) : null,
        description && typeof description !== 'object' ? m('.play-together-card-flow-header__description', m.trust(description)) : null
      ]);
    };

    // Public functions:
    return CardFlowHeader;
  });
